"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreefulNode = function TreefulNode(id) {
	var data = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

	_classCallCheck(this, TreefulNode);

	var _id = id;
	var _data = data;
	var _callbacks = [];
	var _children = {};
	var _hashId = 0;

	this.add = function (node) {
		var branch = {};
		branch[node.getId()] = node;
		_children = Object.assign(_children, branch);
		node.subscribe(callCallbacks);
	};

	this.setData = function (data) {
		_data = data;
		callCallbacks(_data, _id, true);
	};

	this.getId = function () {
		return _id;
	};

	this.getData = function () {
		return _data;
	};

	this.getChildren = function () {
		return _children;
	};

	this.getCallbacks = function () {
		return _callbacks;
	};

	this.subscribe = function (callback, ignoreChildren) {
		var hashId = _hashId;
		_callbacks.push({ hashId: hashId, callback: callback, ignoreChildren: ignoreChildren });
		_hashId++;
		return function () {
			unsubscribe(hashId);
		};
	};

	var unsubscribe = function unsubscribe(index) {
		for (var i = 0; i < _callbacks.length; i++) {
			if (_callbacks[i].hashId == index) {
				_callbacks.splice(i, 1);
				break;
			}
		}
	};

	var callCallbacks = function callCallbacks(data, id) {
		var self = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

		_callbacks.forEach(function (item) {
			if (!item.ignoreChildren || self) {
				item.callback(data, id);
			}
		});
	};
};

exports.default = TreefulNode;